import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { COMPONENT_LIST_INIT_SORT } from "../constants";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
export const initFilter = {
    product_or_type: null,
    publisher: null,
    task: null,
    license_family: null,
    hasUnknownType: false,
};
export const initSort = {
    property: "component_count",
    reverse: true,
};
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: {},
    focusedRow: null,
};
const mlbomSlice = createSlice({
    name: "mlbom",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = action.payload;
            state.expandedRows = {};
            state.focusedRow = null;
            state.pagination.currentPage = 1;
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.expandedRows = {};
            state.focusedRow = null;
            state.pagination.currentPage = 1;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.id] = {
                    pagination: initPagination,
                    sortBy: COMPONENT_LIST_INIT_SORT,
                };
            }
            else {
                delete state.expandedRows[action.payload.id];
            }
        },
        expandedRowPaginationUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].pagination =
                    action.payload.pagination;
            }
        },
        expandedRowSortUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].sortBy = action.payload.sort;
                state.expandedRows[action.payload.id].pagination.currentPage = 1;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "mlbom");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
    },
});
export const mlbomReducer = mlbomSlice.reducer;
export const { filterUpdated, sortUpdated, paginationUpdated, expandedRowsUpdated, expandedRowPaginationUpdated, expandedRowSortUpdated, focusedRowUpdated, } = mlbomSlice.actions;
export const selectFilter = (state) => state.report.mlbom.filter;
export const selectSort = (state) => state.report.mlbom.sort;
export const selectPagination = (state) => state.report.mlbom.pagination;
export const selectExpandedRow = (state, id) => state.report.mlbom.expandedRows[id] !== undefined;
export const selectExpandedRowPagination = (state, id) => { var _a, _b; return (_b = (_a = state.report.mlbom.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.pagination) !== null && _b !== void 0 ? _b : initPagination; };
export const selectExpandedRowSort = (state, id) => { var _a, _b; return (_b = (_a = state.report.mlbom.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.sortBy) !== null && _b !== void 0 ? _b : COMPONENT_LIST_INIT_SORT; };
export const selectFocusedRow = (state) => state.report.mlbom.focusedRow;
export * as default from "./mlbomSlice";
//# sourceMappingURL=mlbomSlice.js.map